import { createContext, useState } from "react";
import api from "./api";

const MaterialContext = createContext();

const MaterialProvider = ({ children }) => {
  const [id, setId] = useState();
  const [materialInfos, setMaterialInfos] = useState([]);

  const getMaterialInfoList = async (force) => {
    if (materialInfos.length > 0 && !force) return materialInfos;

    const response = await api.getMaterialInfoList();
    setMaterialInfos(response.data);

    return response.data;
  };

  const getMaterialInfoListByCompany = async (companyId, force) => {
    if (materialInfos.length > 0 && !force) return materialInfos;

    const response = await api.getMaterialInfoListByCompany(companyId);
    setMaterialInfos(response.data);

    return response.data;
  };

  const values = {
    id,
    getMaterialInfoList,
    getMaterialInfoListByCompany,
  };

  return (
    <MaterialContext.Provider value={values}>
      {children}
    </MaterialContext.Provider>
  );
};

export { MaterialContext, MaterialProvider };
